import React from 'react';

import debounce from 'lodash/debounce';

interface Props {
  type?: string;
  value?: string;
  delay?: number;
  onChange: (value: string) => unknown;
  autoFocus?: boolean;
  className?: string;
  placeholder?: string;
}
type State = {
  value: string;
};
export class DebouncedInput extends React.Component<Props, State> {
  static defaultProps = {
    delay: 2000,
    type: 'text',
  };

  hasPendingChange = false;

  delayedOnChange: {
    (arg0: string): any;
    cancel: () => void;
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      value: props.value || '',
    };
    this.delayedOnChange = debounce(this.handleDelayedChange, props.delay);
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (nextProps.value !== this.props.value) {
      this.cancelDelayedChange();
      this.setState({
        value: nextProps.value!,
      });
    }
  }

  componentWillUnmount() {
    this.sync();
  }

  cancelDelayedChange() {
    this.delayedOnChange.cancel();
    this.hasPendingChange = false;
  }

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({
      value,
    });
    this.hasPendingChange = true;
    this.delayedOnChange(value);
  };

  handleDelayedChange = (value: string) => {
    this.hasPendingChange = false;
    this.props.onChange(value);
  };

  sync = () => {
    if (this.hasPendingChange) {
      this.cancelDelayedChange();
      this.props.onChange(this.state.value);
    }
  };

  handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    e.persist();
    // we need wait for onChange handler to run
    // so the value is updated and the delayed change can be canceled
    setTimeout(() => {
      if (e.key === 'Enter') {
        this.cancelDelayedChange();
        this.handleDelayedChange(this.state.value);
      }
    }, 0);
  };

  render() {
    // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
    const {delay, type, value, onChange, ...other} = this.props;
    return (
      <input
        {...other}
        type={type}
        value={this.state.value}
        onChange={this.handleChange}
        onKeyPress={this.handleKeyPress}
        onBlur={this.sync}
      />
    );
  }
}
